import React, { useCallback, useMemo } from 'react';
import { AutocompleteFilter } from "../form/AutocompleteField";
import { IdWithName } from "../../../model/IdWithName";
import { OnFilterChange } from "../../hooks/useTable";

const GeneralAutocompleteFilter: React.FC<GeneralAutocompleteFilterProps> = props => {
    const onFilterChange = useCallback(
        (values: IdWithName[] | IdWithName) => props.onFilterChange(
            props.name, Array.isArray(values) ? values.map(v => v.id) : values?.id
        ),
        []
    );

    const getOptionLabel = useCallback((value: IdWithName) => value.name, []);

    const options: IdWithName[] = useMemo(
        () => (props.options || []).map(
            option => typeof option === 'string' ? { id: option, name: option } : option
        ),
        [props.options]
    );

    const value = useMemo(
        () => {
            const value = Array.isArray(props.values)
                ? options?.filter(option => (props.values as Value[])?.includes(option.id))
                : options?.filter(option => option.id === props.values).pop();

            if (props.multiple && !value) {
                return [];
            }

            return value;
        },
        [options, props.values]
    );

    return (
        <AutocompleteFilter
            isLoading={ props.isLoading }
            multiple={ props.multiple }
            label={ props.label }
            options={ options }
            getOptionLabel={ getOptionLabel }
            onChange={ onFilterChange }
            size='small'
            value={ value }
        />
    );
}
export default GeneralAutocompleteFilter;

export interface GeneralAutocompleteFilterProps {
    readonly isLoading?: boolean;
    readonly options: Option[] | undefined
    readonly name: string;
    readonly values: Value[] | Value | undefined;
    readonly onFilterChange: OnFilterChange;
    readonly multiple?: boolean;
    readonly label?: string;
}

export interface ConcreteAutocompleteFilterProps {
    readonly name?: string;
    readonly label?: string;
    readonly options: Option[] | undefined
    readonly values: Value[] | Value | undefined;
    readonly onFilterChange: OnFilterChange;
}

type Value = string | number;
type Option = string | IdWithName;